/* Auto Language Redirect. Business rule: the first time a visitor arrives on the storefront,
   detect their real IP country and, if that country maps to a published language other than
   the one currently showing, silently switch them to it - by reusing the site's own native
   language-switcher form (the {% form 'localization' %} in sections/footer.liquid), the exact
   same mechanism a visitor clicking that switcher themselves would trigger, rather than
   hand-building locale URLs.

   Country lookup goes through window.getVisitorCountry() (defined in assets/theme.js) - a
   shared, memoized fetch also used by ip-restrict.js and redirect-nl.js, so all 3 features
   together ever trigger at most one real network request per page load, instead of one each.

   "First visit only": a sessionStorage flag is set the first time this check successfully runs
   (fetch resolved, whether or not it led to a redirect), so a visitor is never redirected again
   after that - including if they manually pick a different language afterward. If sessionStorage
   is unavailable for any reason, the check is skipped entirely (fail closed) rather than risk
   re-redirecting on every single page load.

   Unmatched country (anything not in COUNTRY_LANGUAGE_MAP, including the Netherlands itself) -
   no redirect at all, visitor stays on whatever they landed on, which defaults to the plain NL
   site.

   Otherwise independent from ip-restrict.js/redirect-nl.js - own mapping, own storage key, own
   redirect logic - only the country lookup itself is shared, so this can never affect those
   already-working, separately-tested features beyond that one shared function.

   Accepted trade-off: this script is loaded deferred, so there is a brief flash of the page in
   its original language before the redirect fires - not an instant server-side redirect.

   Country / market: on the same first-visit check, if the IP country has its own Shopify market
   (MARKET_COUNTRIES) and differs from the active Shopify.country, the country is set too, via
   country_code on the same native localization form. Shopify won't do this itself on a .nl
   domain (EU ccTLD exception to automatic redirection), so without it every visitor gets the NL
   market and NL catalog prices. Language and country stay independent: a later manual language
   switch keeps the country (Shopify remembers it), and prices always come from the market's
   catalog - nothing here touches displayed prices.
*/
(function () {
  var STORAGE_KEY = 'vp_lang_redirect_checked';

  // Country (ISO 3166-1 alpha-2, as returned by Shopify's own geolocation endpoint) -> target
  // published language code (matches the value on each language-switcher button in
  // sections/footer.liquid). GB is the real ISO code for the United Kingdom (not "UK") - worth
  // double-checking live if this ever seems not to trigger for a UK test.
  var COUNTRY_LANGUAGE_MAP = {
    DE: 'de',
    FR: 'fr',
    GB: 'en',
    US: 'en',
    IE: 'en',
    CA: 'en',
    AU: 'en',
    NZ: 'en'
  };

  // Countries that have their own market + catalog (Markets in the Shopify admin). Keep in sync
  // when a market is added or removed - a country not listed here keeps the default NL market.
  var MARKET_COUNTRIES = ['NL', 'BE', 'DE', 'FR', 'IE', 'LU', 'AT', 'CZ', 'DK'];

  function alreadyChecked() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return true;
    }
  }

  function markChecked() {
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}
  }

  // Returns true if a redirect was started.
  function switchLanguage(code, countryCode) {
    var btn = document.querySelector('button[name="language_code"][value="' + code + '"]');
    if (!btn) return false;
    if (countryCode && btn.form) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'country_code';
      input.value = countryCode;
      btn.form.appendChild(input);
    }
    btn.click();
    return true;
  }

  // Country only, language unchanged: post to the same /localization endpoint and come back to
  // the current page.
  function switchCountry(countryCode) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var form = document.createElement('form');
    form.method = 'post';
    form.action = root + 'localization';
    form.style.display = 'none';
    var fields = {
      form_type: 'localization',
      utf8: '‚úì',
      _method: 'put',
      return_to: window.location.pathname + window.location.search,
      country_code: countryCode
    };
    Object.keys(fields).forEach(function (name) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = fields[name];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
    return true;
  }

  if (alreadyChecked()) return;

  if (window.beginRedirectCheck) window.beginRedirectCheck();

  window.getVisitorCountry().then(function (country) {
    markChecked();

    var currentCountry = ((window.Shopify && window.Shopify.country) || '').toUpperCase();
    var targetCountry =
      country && MARKET_COUNTRIES.indexOf(country) !== -1 && country !== currentCountry ? country : null;

    var currentLanguage = ((window.themeSettings || {}).currentLanguage || 'NL').toLowerCase();
    var targetLanguage = country && COUNTRY_LANGUAGE_MAP[country];
    if (targetLanguage === currentLanguage) targetLanguage = null;

    var redirecting = false;
    if (targetLanguage) {
      redirecting = switchLanguage(targetLanguage, targetCountry);
    }
    if (!redirecting && targetCountry) {
      redirecting = switchCountry(targetCountry);
    }

    // No finishRedirectCheck() when a redirect is starting.
    if (!redirecting && window.finishRedirectCheck) window.finishRedirectCheck();
  });
})();